export { default } from './ChanceOfScoringGraph';
